import request from '@/router/axios'
// 获取企业信息列表
export function fetchList(query) {
  return request({
    url: '/platformCompany/',
    method: 'post',
    params: query
  })
}

//获取通用标签信息
export function getdicts(query) {
  return request({
    url: '/dict/getWxMiniAppDicts',
    method: 'post',
    params: query
  })
}

// 获取企业信息列表
export function getCompanyInfo(query) {
    return request({
      url: '/platformCompany/info',
      method: 'post',
      params: query
    })
  }
// 获取员工信息列表 
export function getWorkerInfo(query) {
  return request({
    url: '/platformCompany/userList',
    method: 'post',
    params: query
  })
}
export function addObj(obj) {
  return request({
    url: '/platformUser/insert',
    method: 'post',
    params: obj
  })
}

export function getObj(obj) {
  return request({
    url: '/platformUser/info',
    method: 'post',
    params: obj
  })
}

export function delObj(id) {
  return request({
    url: '/admin/user/' + id,
    method: 'delete'
  })
}

export function putObj(obj) {
  return request({
    url: '/platformUser/update',
    method: 'post',
    params: obj
  })
}
export function selectState(obj) {
    return request({
      url: '/platformCompany/updateStatus',
      method: 'post',
      params: obj
    })
  }

// 获取所有角色
export function roleList(query) {
  return request({
    url: '/role/rolePage',
    method: 'post',
    params: query
  })
}

// 停用
export function stop(query) {
    return request({
      url: '/platformUser/updateStatus',
      method: 'post',
      params: query
    })
  }

  //获取二维码
  export function getewm(query) {
    return request({
      url: '/wxmp/qrCodeBangding',
      method: 'post',
      params: query
    })
  }

  //获取通用标签信息
export function updateStakeholders(data) {
  return request({
    url: '/companyProject/updateStakeholders',
    method: 'post',
    params: data
  })
}